import React, { useMemo, useState, useEffect } from "react";
import { Formik, Form, Field, useFormik } from "formik";
import CustomDatePicker from "common/CustomDatePicker";
import CustomSelect from "components/Common/custom-select";
import * as Yup from "yup";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col, Input, CardBody, Container, Card } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Breadcrumbs from "components/Common/Breadcrumb";
import { fetchCategories, fetchDepartments, fetchDesignations,fetchEmployeeDropdownAutoList,resetEmployeeShiftProcess } from "store/actions";
import { fetchEmployeeShiftProcess,SaveEmployeeShiftProcess } from "store/attendance/biometric/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import TableContainer from "components/Common/TableContainer";
import Swal from "sweetalert2";
import Header from "components/VerticalLayout/Header";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";
// Sample dropdown options

const ShiftProcess = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
    // Validation Schema using Yup
    const validationSchema = Yup.object().shape({
        // category: Yup.array().min(1, "Select at least one category"),
        // department: Yup.array().min(1, "Select at least one department"),
        // designation: Yup.array().min(1, "Select at least one designation"),
        // employeeCode: Yup.string().required("Employee Code is required"),
        fromDate: Yup.date().nullable().required("From Date is required"),
        toDate: Yup.date().nullable().required("To Date is required").min(Yup.ref("fromDate"), "To Date cannot be before From Date"),
    });

    const [authDetails, setAuthDetails] = useState(null);
    const { 
        categories, 
        departments, 
        designations,
        dropdownAutoList,
        employeeShiftProcess,
        loading,
        success,
        error, 
      } = useSelector((state) => ({
          categories: state.CategoryMaster?.categories,
          departments: state.DepartmentMaster?.departments,
          designations: state.DesignationMaster?.designations,
          dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
          employeeShiftProcess: state.AttendanceBiometricReducer?.employeeShiftProcess ?? [],

          loading: state.CategoryMaster?.loading,
          error: state.AttendanceTimeDeductionsReducer?.error,
          success: state.AttendanceBiometricReducer?.success 
      })); 
    const dispatch = useDispatch()

    useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);

    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchDepartments(unitId));
        dispatch(fetchCategories(unitId));
        dispatch(fetchDesignations(unitId));
        const unit_id= authUserDetails[0].unit_id
        dispatch(fetchEmployeeDropdownAutoList(unit_id));
    }, [dispatch]);

    const formik = useFormik({
        initialValues: {
            category: [],
            department: [],
            designation: [],
            employee: [],
            fromDate: "",
            toDate: "",
            delete_existing_shift: false,
        },
        validationSchema,
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append("cat_id", values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0');
            formData.append("dept_id", values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0');
            formData.append("desig_id", values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0');
            formData.append("emp_id", values.employee?.value || "0" );
            formData.append("from_date", values.fromDate);
            formData.append("to_date", values.toDate);
            formData.append("unit_id", authDetails?.unit_id);
            formData.append("create_by", authDetails?.user_id);

            dispatch(fetchEmployeeShiftProcess(formData));
        },
    });   

    const handleShiftProcess = async (e) => {
        e.preventDefault();

        if (formik.values.fromDate === "" || formik.values.fromDate === null || formik.values.fromDate === undefined) { 
              Swal.fire({ icon: "warning", title: "No Selection", text: "Please select From Date", });
            return false; 
        }
        else if (formik.values.toDate === "" || formik.values.toDate === null || formik.values.toDate === undefined) { 
              Swal.fire({ icon: "warning", title: "No Selection", text: "Please select To Date", });
            return false; 
        }
        else {
            const formData = new FormData();
            formData.append("cat_id", formik.values.category && formik.values.category.length ? formik.values.category.map(item => item.value).join(",") : '0');
            formData.append("dept_id", formik.values.department && formik.values.department.length ? formik.values.department.map(item => item.value).join(",") : '0');
            formData.append("desig_id", formik.values.designation && formik.values.designation.length ? formik.values.designation.map(item => item.value).join(",") : '0');
            formData.append("emp_id", formik.values.employee?.value || "0" );
            formData.append("from_date", formik.values.fromDate);
            formData.append("to_date", formik.values.toDate);
            formData.append("unit_id", authDetails?.unit_id);
            formData.append("create_by", authDetails?.user_id);
            formData.append("is_delete", formik.values.delete_existing_shift ? "1" : "0");

            dispatch(SaveEmployeeShiftProcess(formData));
        }
    }

    // select custome style
    const SelectcustomStyles = {
        control: (base) => ({
            ...base,
            maxheight: 33.1,
            minHeight: 33.1,
            // overflow: "scroll",
        }),
        indicatorsContainer: (base) => ({
            ...base,
            padding: "0", // Match the padding for both dropdown and clear indicator
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: "2px 8px", // Ensure consistent padding for dropdown indicator
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
        }),
    };

    let shiftData = [];
    if (Array.isArray(employeeShiftProcess) && employeeShiftProcess.length > 0) {
        shiftData = employeeShiftProcess.map(emp => {
            const dynamicDates = Object.keys(emp).filter(k => !['emp_no', 'emp_name', 's_no'].includes(k));
            const dateShifts = dynamicDates.reduce((acc, key) => { acc[key] = emp[key]; return acc; }, {});

            return { Code: emp.emp_no, Name: emp.emp_name, ...dateShifts };
        });
    }
    
    const columns = useMemo(() => {
        if (!Array.isArray(employeeShiftProcess) || employeeShiftProcess.length === 0) {
            return [];
        }
        return [
            {
                Header: "S.No",
                Cell: ({ row }) => shiftData.length - row.index,
                className: "serial-no",
                applyHeaderClass: true,
            },
            {
                Header: "Code",
                accessor: "Code",
            },
            {
                Header: "Name",
                accessor: "Name",
            },
            ...Object.keys(employeeShiftProcess[0])
                .filter(k => !['emp_no', 'emp_name', 's_no'].includes(k))
                .map(dateKey => ({
                    Header: dateKey,
                    accessor: row => row[dateKey],  // <-- key fix here!
                    id: dateKey,                    // <-- needed when using accessor function
                    Cell: ({ value }) => (<div className="text-center">{value || "-"}</div>),
                    className: "bg-date",
                    applyHeaderClass: true,
                })),
        ];

    }, [employeeShiftProcess]);
    
    const handleCancel = () => {
        formik.resetForm()
        dispatch(resetEmployeeShiftProcess());
        //dispatch(resetAll)
    }

    useEffect(() => {
        if (success) {
            handleCancel()
        }
    }, [authDetails, success, dispatch]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Loader loading={loading} />
                <Container fluid>
                    <Breadcrumbs title="Shift Management" breadcrumbItem="Shift Process" />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <form onSubmit={formik.handleSubmit} >
                                        <Row>
                                            {/* Category */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Category</Label>
                                                    <Select
                                                        id="category"
                                                        name="category"
                                                        options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                                                        value={formik.values.category || null}
                                                        onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={`${formik.touched.category && formik.errors.category ? 'is-invalid' : ''} hrms-select`}
                                                        classNamePrefix="hrms-select"
                                                        styles={SelectcustomStyles}
                                                    />
                                                    {formik.errors.category && formik.touched.category && (
                                                        <div className="text-danger">{formik.errors.category}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* Department */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Department</Label>
                                                    <Select
                                                        id="department"
                                                        name="department"
                                                        options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                                                        value={formik.values.department || null}
                                                        onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={`${formik.touched.department && formik.errors.department ? 'is-invalid' : ''} hrms-select`}
                                                        classNamePrefix="hrms-select"
                                                        styles={SelectcustomStyles}

                                                    />
                                                    {formik.errors.department && formik.touched.department && (
                                                        <div className="text-danger">{formik.errors.department}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* Designation */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Designation</Label>
                                                    <Select
                                                        id="designation"
                                                        name="designation"
                                                        options={designations.map(desig => ({ value: desig.desig_id, label: desig.designation }))}
                                                        value={
                                                            designations
                                                                .filter(desig => formik.values.designation?.includes(desig.desig_id))
                                                                .map(desig => ({ value: desig.desig_id, label: desig.designation }))
                                                        }
                                                        onChange={val => formik.setFieldValue('designation', val ? val.map(v => v.value) : [])}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={`${formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''} hrms-select`}
                                                        classNamePrefix="hrms-select"
                                                        styles={SelectcustomStyles}

                                                    />
                                                    {formik.errors.designation && formik.touched.designation && (
                                                        <div className="text-danger">{formik.errors.designation}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            {/* Employee Code */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Employee Code</Label>
                                                    <CustomSelect
                                                        id="employee"
                                                        name="employee"
                                                        options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                                                        value={formik.values.employee || null}  // Store full object
                                                        onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                                                    />
                                                    {formik.errors.employeeCode && formik.touched.employeeCode && (
                                                        <div className="text-danger">{formik.errors.employeeCode}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* From Date */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>
                                                        From Date <span className="text-danger">*</span>
                                                    </Label>
                                                    <CustomDatePicker
                                                        name="fromDate"
                                                        value={formik.values.fromDate || null}
                                                        selected={formik.values.fromDate}
                                                        onChange={date => formik.setFieldValue("fromDate", date || null)}
                                                        onBlur={() => formik.setFieldTouched("fromDate", true)}
                                                    />
                                                    {formik.errors.fromDate && formik.touched.fromDate && (
                                                        <div className="text-danger">{formik.errors.fromDate}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* To Date */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>
                                                        To Date <span className="text-danger">*</span>
                                                    </Label>
                                                    <CustomDatePicker
                                                        name="toDate"
                                                        value={formik.values.toDate || null}
                                                        selected={formik.values.toDate}
                                                        onChange={date => formik.setFieldValue("toDate", date || null)}
                                                        onBlur={() => formik.setFieldTouched("toDate", true)}
                                                    />
                                                    {formik.errors.toDate && formik.touched.toDate && (
                                                        <div className="text-danger">{formik.errors.toDate}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3} className="d-flex align-items-center"> 
                                                {/* Search Button */}     
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input
                                                            type="checkbox"
                                                            id="delete_existing_shift"
                                                            className="me-2"
                                                            checked={formik.values.delete_existing_shift}
                                                            onChange={formik.handleChange}
                                                        />
                                                    Delete the Existing Shift
                                                    </Label>
                                                </FormGroup>        
                                                {/* <Label for="deleteexistingshift" className="mb-0 d-flex align-items-center">
                                                   
                                                </Label>                                     */}
                                            </Col>                                            
                                        </Row>
                                        <Row>
                                            <Col className="d-flex align-items-center justify-content-end">
                                                <Button type="submit" className="btn button-search me-2">
                                                    <i className="fas fa-search me-1" /> Search
                                                </Button>
                                                <Button type="reset" color="secondary" onClick={handleCancel} className="btn button-cancel me-2"> <i className="fas fa-sync me-1" /> Cancel
                                                </Button>
                                                {canCreate && (
                                                    <Button type="button" onClick={handleShiftProcess} className="btn button-save">
                                                        <i className="fas fa-spinner me-1 " /> Process
                                                    </Button>
                                                )}
                                                
                                            </Col>
                                        </Row>
                                                                               
                                    </form>
                                </CardBody>
                            </Card>

                            <Card>
                                <CardBody>
                                    <TableContainer
                                        columns={columns}
                                        data={shiftData && shiftData.length > 0 ? shiftData : []}
                                        isGlobalFilter={true}
                                        customPageSize={10}
                                        className="custom-header-css"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ShiftProcess;
